import { z } from "zod";
import { config } from "../../config/config";
import { authHeaders, handleV2Error } from "./_helpers";
import {
  paymentMethodSchema,
  type PaymentMethodResponse,
} from "../../utils/zod/paymentMethod";

export type {
  PaymentMethodResponse,
  TicketConfig,
  TaxConfig,
  CommissionSettings,
  PaymentMethodAdditionalSettings,
} from "../../utils/zod/paymentMethod";

export const getPaymentMethodsRequest = async (
  token: string,
): Promise<PaymentMethodResponse[]> => {
  const response = await fetch(`${config.API_V2_URL}/v2/payment-methods`, {
    method: "GET",
    headers: authHeaders(token),
  });

  if (!response.ok) await handleV2Error(response);

  const body = await response.json();
  return z.array(paymentMethodSchema).parse(body.data);
};
